export default __webpack_public_path__ + "static/media/calendar-active.6365d749.svg";